import React from "react";
import { Link } from "react-router-dom";
// import { Buffer } from "buffer";
import Loader from "../loader/Loader";

export default function BlogCard({ blogs }) {
  const theme_color = localStorage.getItem("theme");
  return (
    <>
      {!blogs ? (
        <Loader />
      ) : (
        <>
          {blogs &&
            blogs.slice(0, 6).map((curElem) => {
              const {
                _id,
                blog_feature_img,
                category,
                createdAt,
                description,
                title,
                author,
                author_profile,
              } = curElem;
              var date = new Date(createdAt);
              let splitedDate = date.toString().split(" ");
              let month = splitedDate[1];
              let day = splitedDate[2];
              let year = splitedDate[3];
              var hours = date.getHours();
              var minutes = date.getMinutes();
              var ampm = hours >= 12 ? "pm" : "am";
              hours = hours % 12;
              hours = hours ? hours : 12; // the hour '0' should be '12'
              hours = hours < 10 ? "0" + hours : hours;
              minutes = minutes < 10 ? "0" + minutes : minutes;
              var dateTime = month + ", " + day + " " + year;
              {
                /* +
                " at " +
                hours +
                ":" +
                minutes +
                " " +
                ampm; */
              }
              return (
                <div className="col-lg-4 mb-4" key={_id}>
                  <div className="card text-start">
                    <div className="card-img">
                      <Link to={"/single/" + _id}>
                        <img src={blog_feature_img} className="w-100" alt="" />
                      </Link>
                    </div>
                    <div className="card-body">
                      <Link
                        to={
                          "/category/" +
                          category.toLowerCase().replace(" ", "-")
                        }
                        className={"m-0 Category text-" + theme_color}
                      >
                        {category}
                      </Link>
                      <Link to={"/single/" + _id}>
                        <h3 className="m-0">{title}</h3>
                      </Link>
                      <small className="m-0">
                        {"Published at: " + dateTime}
                      </small>
                      <div
                        className="m-0 desc"
                        dangerouslySetInnerHTML={{
                          __html: description,
                        }}
                      ></div>
                      <div className="user d-flex align-items-center">
                        <div className="user-img">
                          <img src={author_profile} alt="" />
                        </div>
                        <div className="user-name">
                          <Link
                            to={
                              "/author/" +
                              author.toLowerCase().replace(" ", "-")
                            }
                            className="m-0"
                          >
                            {author}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          {blogs && blogs.length > 6 && (
            <div className="see-more">
              <Link className="btn btn-md btn-warning" to={"/blogs"}>
                See More
              </Link>
            </div>
          )}
        </>
      )}
    </>
  );
}
